/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './blood-donor-fitness.reducer';

export const BloodDonorFitnessDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bloodDonorFitnessEntity = useAppSelector(state => state.bloodDonorFitness.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bloodDonorFitnessDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.detail.title">BloodDonorFitness</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.id">Id</Translate>
            </span>
          </dt>
          <dd>{bloodDonorFitnessEntity.id}</dd>
          <dt>
            <span id="bloodType">
              <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.bloodType">Blood Type</Translate>
            </span>
          </dt>
          <dd>{bloodDonorFitnessEntity.bloodType}</dd>
          <dt>
            <span id="hbLevel">
              <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.hbLevel">Hb Level</Translate>
            </span>
          </dt>
          <dd>{bloodDonorFitnessEntity.hbLevel}</dd>
          <dt>
            <span id="counselor">
              <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.counselor">Counselor</Translate>
            </span>
          </dt>
          <dd>{bloodDonorFitnessEntity.counselor}</dd>
          <dt>
            <span id="phlebotonist">
              <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.phlebotonist">Phlebotonist</Translate>
            </span>
          </dt>
          <dd>{bloodDonorFitnessEntity.phlebotonist}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.active">Active</Translate>
            </span>
          </dt>
          <dd>{bloodDonorFitnessEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bloodDonorFitnessEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{bloodDonorFitnessEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bloodDonorFitnessEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{bloodDonorFitnessEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.donorType">Donor Type</Translate>
          </dt>
          <dd>{bloodDonorFitnessEntity.donorType ? bloodDonorFitnessEntity.donorType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.vitals">Vitals</Translate>
          </dt>
          <dd>{bloodDonorFitnessEntity.vitals ? bloodDonorFitnessEntity.vitals.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.atCamp">At Camp</Translate>
          </dt>
          <dd>{bloodDonorFitnessEntity.atCamp ? bloodDonorFitnessEntity.atCamp.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/blood-donor-fitness" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/blood-donor-fitness/${bloodDonorFitnessEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BloodDonorFitnessDetail;
